import { Button, Form, Input, Modal, Select } from 'antd';

import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/ProductCategories/components/AddEditProductCategory/data';
import {
  useAddEditProductCategory,
  useAddEditProductCategoryEffects,
} from '@app/pages/Warehouses/ProductCategories/components/AddEditProductCategory/hooks';
import type {
  AddEditProductCategoryForm,
  AddEditProductCategoryType,
} from '@app/pages/Warehouses/ProductCategories/components/AddEditProductCategory/types';

import '@pages/Warehouses/ProductCategories/components/AddEditProductCategory/styles/AddEditProductCategory.scss';

const { Item } = Form;
const { TextArea } = Input;

export const AddEditProductCategory: AddEditProductCategoryType = ({
  mode = 'add',
}) => {
  const {
    form,
    initForm,
    onFinish,
    openDeleteModal,
    closeDeleteModal,
    onDelete,
    isDeleteOpen,
    onCancel,
    disabledForm,
    skipForm,
    categoriesOptions,
    isPageForbidden,
    IsProductCategoryDelete,
  } = useAddEditProductCategory({ mode });

  useAddEditProductCategoryEffects({ initForm, skipForm });

  if (isPageForbidden) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <>
      <div className={`${PF}_container`}>
        <Form<AddEditProductCategoryForm>
          form={form}
          layout="horizontal"
          labelAlign="left"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 10 }}
          className={`${PF}_form`}
          name={`${PF}_form`}
          onFinish={onFinish}
        >
          <Item
            name="Name"
            label="Название"
            rules={[{ required: true, message: 'Введите название категории' }]}
          >
            <Input
              type="text"
              placeholder="Введите название"
              disabled={disabledForm}
            />
          </Item>

          <Item name="ParentCategoryId" label="Родительская категория">
            <Select
              options={categoriesOptions}
              placeholder="Выберите родительскую категорию"
              allowClear
              disabled={disabledForm}
            />
          </Item>

          <Item name="Comment" label="Примечание">
            <TextArea
              placeholder="Введите примечание категории"
              rows={6}
              disabled={disabledForm}
              maxLength={4000}
            />
          </Item>

          <div className={`${PF}_buttons`}>
            <Button
              type="primary"
              htmlType="submit"
              className={`${PF}_buttons_item`}
              disabled={disabledForm}
              loading={disabledForm}
            >
              Сохранить
            </Button>
            <Button
              type="default"
              className={`${PF}_buttons_item`}
              onClick={onCancel}
              disabled={disabledForm}
            >
              Отменить
            </Button>
            {mode === 'edit' && IsProductCategoryDelete && (
              <Button
                danger
                className={`${PF}_buttons_item`}
                onClick={openDeleteModal}
                disabled={disabledForm}
              >
                Удалить
              </Button>
            )}
          </div>
        </Form>
      </div>
      <Modal
        title="Удаление категории"
        open={isDeleteOpen}
        onCancel={closeDeleteModal}
        onOk={onDelete}
        okText="Удалить"
        cancelText="Отмена"
        okButtonProps={{
          danger: true,
          disabled: disabledForm,
          loading: disabledForm,
        }}
        cancelButtonProps={{ disabled: disabledForm }}
      >
        <p>Вы уверены, что хотите удалить эту категорию?</p>
      </Modal>
    </>
  );
};
